createReducer = (reducers) -> (state = {}, action) ->
  if action.type of reducers
    reducers[action.type](state, action)
  else
    state

module.exports = {
  createReducer
}
